import { atom, DefaultValue, selectorFamily } from 'recoil';
import { fileUploadSchema } from '../../forms';
import { validateSchema } from '../validation';
export const fileUploadAtom = atom({
    key: 'ui/fileUpload',
    default: {},
});
export const fileUploadSelectorFamily = selectorFamily({
    key: 'ui/fileUploadSelectorFamily/select',
    get: (id) => ({ get }) => {
        const fileUpload = get(fileUploadAtom);
        return fileUpload?.[id];
    },
    set: (id) => ({ set, get }, value) => {
        const fileUpload = { ...get(fileUploadAtom) };
        fileUpload[id] = value instanceof DefaultValue ? null : value;
        set(fileUploadAtom, fileUpload);
    },
});
export const fileUploadValidationSelector = selectorFamily({
    key: '@zurich/document/validation/fileupload',
    get: (id) => ({ get }) => {
        const fileUpload = get(fileUploadSelectorFamily(id));
        return validateSchema(fileUploadSchema, fileUpload);
    },
});
